// extracted by mini-css-extract-plugin
module.exports = {"media":"featuredImage_media__WPLhv"};